import { Card, CardContent } from "@/components/ui/card";
import FreelancerPayslipForm from "@/v2/components/pages/payslip/freelancer/Form";
import FormPageHeading from "@/v2/components/ui/heading/FormPage";
import { ReceiptTextIcon } from "lucide-react";

export default function AddFreelancerPayslipPage() {
    return (
        <div className="my-3 min-h-screen">
            <Card className="rounded-xl border-slate-200 shadow-lg dark:border-slate-700">
                <FormPageHeading
                    title="Payslip Management"
                    description="Create and manage employee payslips"
                    Icon={ReceiptTextIcon}
                />
                <CardContent className="pt-6">
                    <FreelancerPayslipForm />
                </CardContent>
            </Card>
        </div>
    );
}
